/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./IconCloseCircle.vue?vue&type=template&id=6dd3d6ee"
import script from "./IconCloseCircle.vue?vue&type=script&lang=js"
export * from "./IconCloseCircle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6dd3d6ee')) {
      api.createRecord('6dd3d6ee', component.options)
    } else {
      api.reload('6dd3d6ee', component.options)
    }
    module.hot.accept("./IconCloseCircle.vue?vue&type=template&id=6dd3d6ee", function () {
      api.rerender('6dd3d6ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icon/IconCloseCircle.vue"
export default component.exports